<ce-tile-basic
    [title]="activeTransactions?.length > 0 ? activeTransactions.length + ' ' + activeSessions : sessions"
    [dialogRoute]="locationId ? ['txs', 'l', locationId] : stationId ? ['txs', stationId] : ['txs']"
    [showHistoricNotice]="true"
    [loading]="loading"
>
    <ng-container tile-content>
        <div fxLayout="column">
            <ce-transaction-badge
                *ngFor="let tx of activeTransactions; trackBy: txTrackBy"
                [tx]="tx"
                [showUtcLabel]="true"
            ></ce-transaction-badge>
            <div i18n="Session tile header|Recent sessions" *ngIf="recentTransactions?.length > 0" class="subtitle">
                recent
            </div>
            <ce-transaction-badge
                *ngFor="let tx of recentTransactions; trackBy: txTrackBy"
                [tx]="tx"
                [showUtcLabel]="true"
            ></ce-transaction-badge>
        </div>
    </ng-container>
</ce-tile-basic>
